var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"agent-report tw-space-y-4"},[_c('h1',{staticClass:"tw-text-xl tw-text-primary tw-font-bold tw-select-none"},[_vm._v(" Agent Report ")]),_c('div',{ref:"chart",staticClass:"chart tw-h-[30rem] tw-w-[50rem] tw-flex tw-justify-center tw-items-center tw-text-gray-300 tw-text-xl"})])
}
var staticRenderFns = []

export { render, staticRenderFns }